import { Avatar, Button, Card, CardContent, CardFooter, CardHeader, Chip, EmptyState, Flex, Heading, Icon, Icons, Paragraph, Image } from "@ir/ui";
import { assetsImages } from "@/assets";
import { useAuth, useUser } from "@/hooks";

const WorkspaceEmpty: React.FC = () => {
  const { logout } = useAuth();
  const { user } = useUser();

  const handleLogout = () => {
    logout();
  };
  return (
    <Flex className="bg-white flex-1" justifyContent="center" align="center">
      <Card className="p-4 m-4">
        <CardHeader className="d-flex flex-column flex-justify-center flex-align-center border-none mt-2">
          <Image src={assetsImages.IRLogoFull} alt="IR Logo" />
        </CardHeader>
        <CardContent>
          <EmptyState
            title={
              <Heading level={3} className="text-center text-grey-400 mt-3 font-bold">
                No workspace assigned
              </Heading>
            }
            description={<Paragraph>You have not been assigned to any workspace yet</Paragraph>}
          ></EmptyState>
        </CardContent>
        <CardFooter className="flex-justify-center border-none">
          {user && (
            <Chip
              size="large"
              label={user.fullName}
              avatar={<Avatar name={user.fullName} src={user.avatar ?? ""} alt={user.fullName} />}
              borderless
              isTransparent
            />
          )}
          <Button variant="outline" onPress={handleLogout} htmlTitle="Log Out">
            Log Out <Icon slot="end" name={Icons.Logout} />
          </Button>
        </CardFooter>
      </Card>
    </Flex>
  );
};
export default WorkspaceEmpty;
